module.exports = __webpack_public_path__ + "static/media/kristina-ljubic.75cf28c6.jpg";